export default __webpack_public_path__ + "static/alpacas-ae05527fe5edce7fe1929ab8ed68086c.png";